module.exports = __webpack_public_path__ + "static/img/1-2.2576425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/1-2.png
// module id = e/3V
// module chunks = 1